export const SHOW_PASSWORD_MODAL = 'SHOW_PASSWORD_MODAL'
export const CLOSE_PASSWORD_MODAL = 'CLOSE_PASSWORD_MODAL'
export const VALIDATION_MESSAGE = 'VALIDATION_MESSAGE'
export const SET_API_ACTION_FEEDBACK = 'SET_API_ACTION_FEEDBACK'
